import '../globalLibraries';
import '../coreLibraries';

// This is the main entry point for a full page microfrontend
//
// adding random string to force recompile:
// A998D3152224818D225A880A9B627F1FB4484DD7E408EACA1B243326ED4AA01B
import ReactComponentMounter from '../utils/react-component-mounter';
import Microfrontend from '../apps/Microfrontend';

ReactComponentMounter.register({
  Microfrontend
});

export { Microfrontend, ReactComponentMounter };
